import { formatPrice } from "./formatPrice";

/**
 * Money that can come out negative, with the minus in front of the dollar sign
 * rather than between it and the digits.
 *
 * The sign is read off the amount rounded to cents, not the raw number. Totals
 * that add signed amounts leave floating-point residue — a month whose charges
 * were all refunded lands a hair below zero — and taking the sign from that
 * would render a plain $0.00 month as -$0.00.
 */
export function formatSignedPrice(amount: number): string {
  const negative = Math.round(amount * 100) < 0;

  return `${negative ? "-" : ""}$${formatPrice(Math.abs(amount))}`;
}
